import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withLandingPage from '../../../components/hoc/withLandingPage';
import { getAsset } from '../../../../../util/assets';
import WaldoProductLogo from '../../../../../components/global/WaldoProductLogo';
import ModalVideoThumbnail from '../../../../../components/global/ModalVideoThumbnail';
import Alert from '../../../../../components/global/Alert';
import Button from '../../../../../components/global/Button';
import { getRoleBasename } from '../../../../../util/role-definitions';
import ACCOUNT_ROLES from '../../../../../constants/account-roles';

class ResortsLanding extends Component {
  static propTypes = {
    resendEmailVerification: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
    emailSent: PropTypes.bool.isRequired,
    error: PropTypes.string,
    isEmailVerified: PropTypes.bool.isRequired,
    isActive: PropTypes.bool.isRequired,
    isUnlocked: PropTypes.bool.isRequired,
    user: PropTypes.shape({
      id: PropTypes.string,
      email_verified: PropTypes.bool,
      active: PropTypes.bool,
    }),
  };

  onDismiss = () => {
    const basename = getRoleBasename(ACCOUNT_ROLES.RESORT_ADMIN);
    this.props.onDismiss(basename);
  };

  renderAlerts = () => {
    const {
      user,
      error,
      emailSent,
      isEmailVerified,
      isActive,
      resendEmailVerification,
    } = this.props;

    return (
      <div>
        {error && (
          <Alert type="danger" className="mb-4">
            {error}
          </Alert>
        )}

        {!isEmailVerified && (
          <Alert type="note" className="mb-4">
            We just sent you an email to verify your email address. Please check
            your inbox and click the link to confirm your email address.
            Didn&rsquo;t get an email?{' '}
            <a href="" onClick={resendEmailVerification}>
              Click here and we&rsquo;ll send you a new one!
            </a>
          </Alert>
        )}

        {emailSent && (
          <Alert type="success" className="mb-4">
            Thanks, we’ve sent you an email at{' '}
            <strong>{user.email_address}</strong>! Please check your mailbox in
            a couple of minutes.
          </Alert>
        )}

        {!isActive && (
          <Alert type="note" className="mb-4">
            Thanks for your interest in bringing Waldo to your
            resort/attraction. One of our resort specialists will get back to
            you lickety split to activate your account.
          </Alert>
        )}
      </div>
    );
  };

  render() {
    const { user, isUnlocked } = this.props;

    return user ? (
      <div>
        {isUnlocked && (
          <button
            onClick={this.onDismiss}
            aria-label="Dismiss"
            className="btn-dismiss btn-landing-dismiss"
          />
        )}

        <div className="welcome-intro text-center mb-6">
          <p className="text-muted mb-0">Welcome to</p>
          <WaldoProductLogo type="resorts" className="d-block" />
        </div>

        <div className="row mb-6">
          <div className="col-lg-4">
            <img
              className="img-round"
              src={getAsset('/landing-pages/resorts-1.jpg')}
              alt=""
            />
          </div>
          <div className="col-lg-4">
            <img
              className="img-round"
              src={getAsset('/landing-pages/resorts-2.jpg')}
              alt=""
            />
          </div>
          <div className="col-lg-4">
            <img
              className="img-round"
              src={getAsset('/landing-pages/resorts-3.jpg')}
              alt=""
            />
          </div>
        </div>

        {this.renderAlerts()}

        <ModalVideoThumbnail
          img={getAsset('/landing-pages/resorts-video-thumb.jpg')}
          className="mb-6 mt-6"
          videoId="1pcowp-8s6I"
        />

        <div className="text-center text-md landing-marketing-copy">
          {isUnlocked && (
            <Button
              onClick={this.onDismiss}
              className="btn-fixed-width mt-1 mr-auto ml-auto"
            >
              Get Started
            </Button>
          )}
        </div>
      </div>
    ) : null;
  }
}

export { ResortsLanding };

export default withLandingPage(ResortsLanding);
